const EMOJI_REGEX =
  /(?:[\u2600-\u27BF]\uFE0F?|[\uD83C][\uDF00-\uDFFF]|[\uD83D][\uDC00-\uDEFF]|[\uD83E][\uDD00-\uDDFF])/g;

const TWEMOJI_CDN =
  "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72";

function getTwemojiCodePoint(emoji) {
  const parts = [];
  for (const char of emoji) {
    const codePoint = char.codePointAt(0);
    if (codePoint === 0xfe0f) continue;
    parts.push(codePoint.toString(16));
  }
  return parts.join("-");
}

function replaceEmojiWithImages(text) {
  return text.replace(EMOJI_REGEX, (emoji) => {
    const codePoint = getTwemojiCodePoint(emoji);
    const src = `${TWEMOJI_CDN}/${codePoint}.png`;
    return `<img class="inline-emoji" src="${src}" alt="${emoji}" draggable="false" />`;
  });
}

export function formatMultilineText(text) {
  if (!text) return "";
  const normalized = String(text)
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\\r/g, "\n")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");
  return replaceEmojiWithImages(normalized).replace(/\n/g, "<br>");
}
